import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateCustomer } from '../services/postCreateCustomer.service';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const createCustomer = createAsyncThunk(
  'customer/createCustomer',
  async (data, { getState }) => {
    const customerData = data;

    const state = getState();
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject.business_id;
    if (!businessId) {
      throw new Error('No business id given');
    }

    const customerCreationData = await postCreateCustomer(
      businessId,
      customerData,
      activeEmployerInfo
    );

    return customerCreationData;
  }
);
